export enum Limit {
    NL = 1,
    PL = 2,
    FL = 4,
    UNKNOWN = 0 // Replay
}